import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgSmartDevice = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.816 6.11h9.423v2.945h.589V4.933a.59.59 0 0 0-.59-.59H5.817a.59.59 0 0 0-.59.59v14.135a.59.59 0 0 0 .59.589h6.478v-.59H5.816v-.588h6.478v-.59H5.816V6.112Zm9.423-1.177v.589H5.816v-.59h9.423Z"
        fill="#374151"
      />
      <path
        d="M18.183 9.645h-4.711a.59.59 0 0 0-.59.588v8.835a.59.59 0 0 0 .59.589h4.711a.59.59 0 0 0 .59-.59v-8.834a.59.59 0 0 0-.59-.588Zm0 .588v.59h-4.711v-.59h4.711Zm0 1.178v6.479h-4.711V11.41h4.711Zm-4.711 7.657v-.59h4.711v.59h-4.711Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgSmartDevice;
